import HttpService from 'Support/services/HttpService';

export default class BoletoRequest {
  static download(id, tipoOperacao) {
    return HttpService.get(
      '/v1/boletos',
      {
        params: {
          tipoOperacao,
          id,
        },
        responseType: 'blob',
      },
    );
  }

  static downloadV2(id) {
    return HttpService.get(
      `/v1/boletos/${id}`,
      {
        responseType: 'blob',
      },
    );
  }
}
